export default __webpack_public_path__ + "static/media/research-se.24cf278e.jpg";